import React from 'react';
import Reflux from 'reflux';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { Button, Row, Col } from 'bootstrap';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import CuesheetResponsiveStore from 'flux/stores/cuesheet/CuesheetResponsiveStore';
import CuesheetResponsiveActions from 'flux/actions/cuesheet/CuesheetResponsiveActions';

import { Icon } from '@shoflo-rundown/polymer.legacy';
import Modal from 'shared/components/misc/modal.jsx';
import ModalActions from 'flux/actions/ModalActions';
import UIRegions from 'shared/constants/UIRegions';
import ModalHelper from './modalHelper';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';
import PresetDurationPicker from 'shared/components/pickers/presetDurationPicker.jsx';

/**
 * Preset Duration Picker Modal component
 *
 */
export default React.createClass({
  mixins: [
    PureRenderMixin,
    Reflux.connectFilter(
      CuesheetStore,
      'rowState',
      ModalHelper.itemConnectFilter(
        (row) =>
          row.getIn(['editing', 'type']) ===
          EditableCellTypes.ItemPresetDuration,
      ),
    ),
    Reflux.connectFilter(CuesheetResponsiveStore, 'modalFields', (st) =>
      st.getIn(['modal', 'fields']),
    ),
  ],

  displayName: 'ItemPresetDurationModal',

  render() {
    return (
      <Modal
        className="csr-modal-item-timer-wrapper"
        name={this._getModalId()}
        onHide={() => CuesheetCellActions.cancelEditing()}
        title="Preset Time"
      >
        <div className="csr-modal-item-timer-content">
          {this._getDurationPickerNode()}
          <Button onClick={this._handleDone}>Save</Button>
        </div>
      </Modal>
    );
  },

  _getDurationPickerNode() {
    const { rowState } = this.state;

    if (!rowState) return null;

    return (
      <div className="duration-picker">
        <div className="text-center">
          <PresetDurationPicker
            showResetButton
            mobile
            value={this._getDurationValue()}
            onChange={this._handleDurationChange}
          />
          {this._getResetButtonNode()}
        </div>
      </div>
    );
  },

  _getResetButtonNode() {
    if (!this.state.rowState.item.get('presetDurationInSeconds')) return null;

    return (
      <Row>
        <Col xs={24}>
          <Icon size={2} onClick={this._handleReset} name="undo" />
        </Col>
      </Row>
    );
  },

  _handleDone() {
    let presetDurationInSeconds = this._getDurationValue();

    let changes = {
      presetDurationInSeconds,
    };

    CuesheetCellActions.saveItemTimeFields(this._getRowIndex(), changes);

    CuesheetResponsiveActions.clearModalFields();
    ModalActions.hide(this._getModalId());
  },

  _handleDurationChange(duration) {
    CuesheetResponsiveActions.updateModalField(
      'presetDurationInSeconds',
      duration,
    );
  },

  _handleReset() {
    const changes = {
      presetDurationInSeconds: 0,
    };

    CuesheetCellActions.saveItemTimeFields(this._getRowIndex(), changes);

    CuesheetResponsiveActions.clearModalFields();
    ModalActions.hide(this._getModalId());
  },

  _getRowIndex() {
    return this.state.rowState.rowIndex;
  },

  _getDurationValue() {
    let { modalFields } = this.state;

    if (
      modalFields &&
      typeof modalFields.get('presetDurationInSeconds') === 'number'
    ) {
      return modalFields.get('presetDurationInSeconds');
    }

    return this.state.rowState.item.get('presetDurationInSeconds');
  },

  _getItem() {
    return this.state.rowState.item;
  },

  _getModalId() {
    return UIRegions.CuesheetItemPresetDuration;
  },

  componentDidUpdate() {
    if (this.state.rowState) {
      ModalActions.show(this._getModalId());
    }
  },
});
